module.exports = __webpack_public_path__ + "img/Fountain.c081ebcd.gif";